import { api } from './client'
import type { VehicleSide } from './types'

export interface AgentJobStatus {
  id?: string
  name?: string
  status?: string
  progress?: number
  attemptsMade?: number
  timestamp?: number
  processedOn?: number
  finishedOn?: number
  failedReason?: string
  returnvalue?: unknown
  output?: Record<string, unknown>
  data?: Record<string, unknown>
  queue?: string
}

export interface ImageUploadResult {
  id: string
  filename: string
  variants: string[]
  requireSignedURLs: boolean
  uploaded: string
  url: string
}

export interface ImageEvaluation {
  imageUrl: string
  side: VehicleSide
  qualityScore: number
  qualityIssues: string[]
  description: string
  qualified: boolean
  reason: string
}

export interface ImageEvaluationResult {
  upload: ImageUploadResult
  evaluation: ImageEvaluation
}

export const agentsApi = {
  /** Upload and evaluate an image via Cloudflare + AI */
  evaluateImage: (file: File) => {
    const formData = new FormData()
    formData.append('image', file)
    return api.post<ImageEvaluationResult>('/agents/images/evaluate', formData)
  },

  /** Check background agent job status. The BE accepts a `?type=`
   *  query param to disambiguate between queues — defaults to
   *  "backgroundAgent" (damage, major-operations, cost). Pass
   *  "sectionsOrchestrator" when polling a sections-orchestrator job. */
  pingJob: (jobId: string, type?: AgentJobType) =>
    api.get<AgentJobStatus>(
      `/agents/ping/${jobId}${type ? `?type=${type}` : ""}`,
    ),
}

export type AgentJobType = "backgroundAgent" | "sectionsOrchestrator"
